//import React from "react";
import React, { useEffect, useContext } from 'react';
import useForm from 'react-hook-form';
import { useTranslation } from 'react-i18next';

// react component
import ReactTable from "react-table";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";
import Edit from "@material-ui/icons/Edit";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";
import GestaoCampanhaForm from "./GestaoCampanhaForm";

// services
import { formateDate } from "beaktShared/helpers/masks";
import { SessionContext } from "beaktShared/services/session";
import { UseGetApiSimple } from "beaktShared/services/crudeApiService";

// styles
import styles from "assets/jss/material-dashboard-pro-react/views/crudeStyle.js";
const useStyles = makeStyles(styles);

export default function GestaoCampanhaList() {
    const { t } = useTranslation();
    const classes = useStyles();
    const endPoint = "campanhas/";
    const session = useContext(SessionContext);
    const { register, getValues, setValue, clearError, setError, errors } = useForm({ mode: "onChange" });

    const [notification, setNotification] = React.useState({
        show: false,
        color: 'info',
        message: ''
    });
    const showNotification = (message, color) => {
        setNotification({
            show: true,
            color: color,
            message: message
        });
        setTimeout(function () {
            setNotification({ show: false });
        }, 4000);
    };
    useEffect(() => {
        LoadListCampanhas();
    }, []);

    //Carrega lista de Campanhas
    const [isLoadingListCampanha, setisLoadingListCampanha] = React.useState(false);
    const [listCampanhas, setlistCampanhas] = React.useState([]);

    const LoadListCampanhas = () => {
        setisLoadingListCampanha(true);
        const endPointGet = endPoint + "byestabelecimento/" + session.estabelecimentoId;
        UseGetApiSimple(endPointGet, 0).then(result => {
            if (result.status !== 200) {
                showNotification(result.message, 'error')
                setisLoadingListCampanha(false);
                return false;
            }
            setisLoadingListCampanha(false);

            let campanhaslist = [];
            result.data.map(obj => {
                campanhaslist.push({
                    campanhaId: obj.campanhaId,
                    nome: obj.nome,
                    tipo: obj.tipoCampanha == 1 ? "Aniversariante" : obj.tipoCampanha == 2 ? "Pacote" : obj.tipoCampanha == 3 ? "Servico" :
                        obj.tipoCampanha == 4 ? "Cortesia" : obj.tipoCampanha == 5 ? "CanalMidia" : obj.tipoCampanha == 6 ? "Profissao" : "" ,
                    vigenciaDe: obj.vigenciaDe,
                    vigenciaAte: obj.vigenciaAte,
                    situacao: obj.situacao == 1 ? "Não Iniciada" : obj.situacao == 2 ? "Em Andamento" :
                        obj.situacao == 3 ? "Vencida" : obj.situacao == 4 ? "Concluída" :
                            obj.situacao == 5 ? "Descontinuada" : ""
                })
            });

            setlistCampanhas(campanhaslist);

            return true;
        });

    };
    //Editar campanha
    const [itemcampanha, setitemcampanha] = React.useState(null);
    const handleEdit = row => {
        let endPointGetCampanha = endPoint + "campanhabyid/" + row.campanhaId;

        UseGetApiSimple(endPointGetCampanha, 0).then(result => {
            if (result.status !== 200) {
                handleView(false);
                return false;
            }
            setitemcampanha(result.data);
            handleView(false);
            return true;
        });

    };
    //colunas Table e Ações
    const columnsProp = [{
        Header: t('label.name'),
        accessor: "nome",
    },
    {
        Header: t('label.campaign_type'),
        accessor: "tipo",
    },
    {
        Header: t('label.validity_of'),
        accessor: "vigenciaDe",
        Cell: (props) => {
            const custom_date = props.value == null ? "" : formateDate(props.value)
            return <span>{custom_date}</span>
        }
    },
    {
        Header: t('label.validity_until'),
        accessor: "vigenciaAte",
        Cell: (props) => {
            const custom_date = props.value == null ? "" : formateDate(props.value)
            return <span>{custom_date}</span>
        }
    },
    {
        Header: t('label.situation'),
        accessor: "situacao",
    }]

    const columnsAcao = [
        {
            Header: t('label.actions'),
            Cell: row => (
                <div className="actions-right">
                    {row.original.situacao == "Não Iniciada" &&
                        <>
                            <Button
                                justIcon
                                round
                                simple
                                color="success"
                                className="edit"
                                onClick={() => handleEdit(row.original)}
                            >
                                <Edit />
                            </Button>{""}
                        </>
                    }

                </div>
            ),
            sortable: false,
            filterable: false
        }
    ];
    const columns = [...columnsProp, ...columnsAcao]

    // nova campanha
    const [disableForm, setdisableForm] = React.useState(false);

    const handleAdd = (item) => {
        handleView(true);
        showNotification(item, 'success');
        LoadListCampanhas();
        return false;
    }

    const [showFormView, setshowFormView] = React.useState(false);

    const handleView = (itemAdd) => {
        if (itemAdd)
            setitemcampanha(null);
            
        let show = showFormView === true ? false : true;
        setshowFormView(show);
    };

    return (

        <div>

            <Snackbar
                place="tr"
                color={notification.color}
                message={notification.message}
                open={notification.show}
                closeNotification={() => setNotification({ show: false })}
                close
            />

            {showFormView && <GestaoCampanhaForm addItem={handleAdd} itemcampanha={itemcampanha} handleView={handleView} disableform={disableForm} />}
            {!showFormView &&
                <div>
                    <GridContainer>
                        <GridItem xs={12}>
                            <Card>
                                <CardHeader color="primary" icon>
                                    <CardIcon color="primary">
                                        <Assignment />
                                    </CardIcon>
                                    <h4 className={classes.cardIconTitle}>{t('sidebar.campaigns_list')} </h4>
                                </CardHeader>
                                <CardBody>
                                    <Button
                                        color="primary"
                                        className={classes.newButton}
                                        onClick={() => handleView(true)}
                                    >
                                        {t('button.new')}
                                    </Button>
                                    <br></br>
                                    <ReactTable
                                        loading={isLoadingListCampanha}
                                        data={listCampanhas}
                                        columns={columns}
                                        filterable={false}
                                        defaultPageSize={10}
                                        minRows={5}
                                        showPaginationBottom={true}
                                        className="-striped -highlight"
                                        previousText={t('button.previous')}
                                        nextText={t('button.next')}
                                        loadingText={t('label.loading') + "..."}
                                        noDataText={t('information_message.no_records_found') + "!"}
                                        pageText={t('label.page')}
                                        ofText={t('label.of')}
                                        rowsText={t('label.rows')}
                                    />
                                </CardBody>
                            </Card>
                        </GridItem>
                    </GridContainer>
                </div>
            }
        </div>
    );
}